"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSignOn = void 0;
const react_native_config_1 = __importDefault(require("react-native-config"));
const Authentication_1 = __importDefault(require("../shared/Authentication"));
class SingleSignOn {
    static Perform(options) {
        let url = global.window.location.origin + '/sso/' + options.provider;
        const queryParams = [];
        queryParams.push('client=' + options.client);
        if (options.additionalRouting != null) {
            queryParams.push(`additionalRouting=${encodeURIComponent(options.additionalRouting)}`);
        }
        if (options.autoNavigate != null) {
            queryParams.push(`autoNavigate=${encodeURIComponent(options.autoNavigate)}`);
        }
        if (options.query) {
            for (let q in options.query) {
                queryParams.push(q + '=' + options.query[q]);
            }
        }
        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }
        global.window.open(url);
    }
    static GetClient() {
        const urlParams = new URLSearchParams(global.window.location.search);
        return urlParams.get('client');
    }
    static IsRedirect() {
        return global.window.location.pathname.startsWith('/sso/');
    }
    static Redirect() {
        Authentication_1.default.GetToken().then(token => {
            const pathWithQuery = global.window.location.pathname + global.window.location.search;
            fetch(react_native_config_1.default.API_URL + pathWithQuery, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Nextep-Client': this.GetClient(),
                    'Nextep-Platform': 'web'
                }
            }).then(response => {
                if (response.status == 200) {
                    if (response.headers.get("content-type") == "text/html")
                        return response.text();
                    else
                        return response.json();
                }
                else {
                    return 'Login Failed';
                }
            }).then(response => {
                if (typeof response === "string") {
                    let root = global.window.document.getElementsByTagName('html')[0];
                    root.innerHTML = response;
                    global.window.document.forms[0].submit();
                }
                else if (response.redirectUrl) {
                    var url = response.redirectUrl;
                    const urlParams = new URLSearchParams(global.window.location.search);
                    const autoNavigate = urlParams.get('autoNavigate');
                    // This is based off what's done in the AdminContext navigation; need to manually alter url to get the pretty version of Report Center
                    if (autoNavigate === 'reportcenter') {
                        url = url.split('/#')[0] + '/apis/ep/sso/report-center-new';
                    }
                    global.window.location.replace(url);
                }
            }).catch(error => {
                console.error(error);
            });
        });
    }
    static RedirectSaml() {
        Authentication_1.default.GetToken().then(token => fetch(react_native_config_1.default.API_URL + '/saml' + global.window.location.search, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Nextep-Platform': 'web'
            }
        }).then(response => {
            if (response.status == 200) {
                return response.text();
            }
            else {
                global.window.location.replace('/login');
            }
        }).then(response => {
            let root = global.window.document.getElementsByTagName('html')[0];
            root.innerHTML = response;
            global.window.document.forms[0].submit();
        })).catch(error => {
            console.error(error);
            global.window.location.replace('/login');
        });
    }
}
exports.SingleSignOn = SingleSignOn;
